import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: the Social › Pinterest › Posts crumb above the list and the editor. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/social/pinterest/posts')({
  staticData: { crumb: 'social:posts.title' },
  component: Outlet,
});
